<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta charset="utf-8"/>
<link href="styles/custom.css" rel="stylesheet" type="text/css"/>
<title>Weapons of Our Warfare</title>
<section epub:type="toc">
<h1 class="ct"><span epub:type="pagebreak" id="page_iv" title="iv">CONTENTS</span></h1>
<p class="toc2"><a href="#/frontmatter#front-1" id="ft-1">FOREWORD</a></p>
<p class="toc2"><a href="#/chapter01#chap-01" id="ch-01">INTRODUCTION</a></p>
<p class="toc"><a href="#/chapter02#chap-02" id="ch-02">1—The Power of His Might</a></p>
<p class="toc"><a href="#/chapter03#chap-03" id="ch-03">2—They Know Not What They Do</a></p>
<p class="toc"><span href="#/chapter04#chap-04" id="ch-04" title="Link target outside of Sample">3—The Whole Armor of God</span></p>
<p class="toc"><span href="#/chapter05#chap-05" id="ch-05" title="Link target outside of Sample">4—Strength Made Perfect</span></p>
<p class="toc"><span href="#/chapter06#chap-06" id="ch-06" title="Link target outside of Sample">5—Fighting the Right Enemy</span></p>
<p class="toc"><span href="#/chapter07#chap-07" id="ch-07" title="Link target outside of Sample">6—The Dual Purpose of the Armor</span></p>
<p class="toc"><span href="#/chapter08#chap-08" id="ch-08" title="Link target outside of Sample">7—Belt of Truth</span></p>
<p class="toc"><span href="#/chapter09#chap-09" id="ch-09" title="Link target outside of Sample">8—Belt of Truth: Part 2</span></p>
<p class="toc"><span href="#/chapter10#chap-10" id="ch-10" title="Link target outside of Sample">9—Breastplate of Righteousness</span></p>
<p class="toc"><span href="#/chapter11#chap-11" id="ch-11" title="Link target outside of Sample">10—Breastplate of Righteousness: Part 2</span></p>
<p class="toc"><span href="#/chapter12#chap-12" id="ch-12" title="Link target outside of Sample">11—Shoes of the Gospel of Peace</span></p>
<p class="toc"><span href="#/chapter13#chap-13" id="ch-13" title="Link target outside of Sample">12—Shoes of the Gospel of Peace: Part 2</span></p>
<p class="toc"><span href="#/chapter14#chap-14" id="ch-14" title="Link target outside of Sample">13—Shield of Faith</span></p>
<p class="toc"><span href="#/chapter15#chap-15" id="ch-15" title="Link target outside of Sample">14—Shield of Faith: Part 2</span></p>
<p class="toc"><span href="#/chapter16#chap-16" id="ch-16" title="Link target outside of Sample">15—Helmet of Salvation</span></p>
<p class="toc"><span href="#/chapter17#chap-17" id="ch-17" title="Link target outside of Sample">16—Helmet of Salvation: Part 2</span></p>
<p class="toc"><span href="#/chapter18#chap-18" id="ch-18" title="Link target outside of Sample">17—Sword of the Spirit</span></p>
<p class="toc"><span href="#/chapter19#chap-19" id="ch-19" title="Link target outside of Sample">18—Sword of the Spirit: Part 2</span></p>
<p class="toc"><span href="#/chapter20#chap-20" id="ch-20" title="Link target outside of Sample">19—Sword of the Spirit: Part 3</span></p>
<p class="toc"><span href="#/chapter21#chap-21" id="ch-21" title="Link target outside of Sample">20—Prayer</span></p>
<p class="toc"><span href="#/chapter22#chap-22" id="ch-22" title="Link target outside of Sample">21—Prayer: Part 2</span></p>
<p class="toc2"><span href="#/backmatter#back-01" id="bk-01" title="Link target outside of Sample">CONCLUSION</span></p>
<p class="toc2"><span href="#/bibliography#bibl-1" id="bib-1" title="Link target outside of Sample">NOTES</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contenttoc.vue?b63f0984